import { SidebarItem } from '@nbx/components';

import { APP_PATHS_SLASH } from '../enums/paths/app.paths';
import { NotFoundRouterHelper } from '../helpers/not-found-router.helper';

export const NAVIGATION_ITEMS: SidebarItem[] = [
  {
    label: 'APP_ROOT.SIDENAV.HOME',
    value: 'home',
    icon: 'pi pi-home',
    routerLink: APP_PATHS_SLASH.HOME,
    routerLinkActiveOptions: { exact: true },
  },
  {
    label: 'APP_ROOT.SIDENAV.RENTALS',
    value: 'rental',
    icon: 'pi pi-building',
    routerLink: APP_PATHS_SLASH.RENTAL,
  },
  {
    label: 'APP_ROOT.SIDENAV.CALENDAR',
    value: 'calendar',
    icon: 'pi pi-calendar',
    routerLink: APP_PATHS_SLASH.CALENDAR,
  },
  {
    label: 'APP_ROOT.SIDENAV.BOOKINGS',
    value: 'booking',
    icon: 'pi pi-key',
    routerLink: APP_PATHS_SLASH.BOOKING,
  },
  {
    label: 'APP_ROOT.SIDENAV.MESSAGES',
    value: 'messages',
    icon: 'pi pi-envelope',
    routerLink: APP_PATHS_SLASH.MESSAGES,
  },
  {
    label: 'APP_ROOT.SIDENAV.CONTACTS',
    value: 'contacts',
    icon: 'pi pi-users',
    routerLink: APP_PATHS_SLASH.CONTACT,
  },
  {
    label: 'APP_ROOT.SIDENAV.STATISTICS',
    value: 'statistics',
    icon: 'pi pi-chart-bar',
    routerLink: APP_PATHS_SLASH.STATISTICS,
  },
].filter(item => NotFoundRouterHelper.shouldShow(item.routerLink));

export const NAVIGATION_BOTTOM_ITEMS: SidebarItem[] = [
  {
    label: 'APP_ROOT.SIDENAV.SETTINGS',
    value: 'settings',
    icon: 'pi pi-cog',
    routerLink: APP_PATHS_SLASH.SETTINGS,
  },
].filter(item => NotFoundRouterHelper.shouldShow(item.routerLink));
